import { defineMessages } from 'react-intl';

export default defineMessages({
    signOut: {
        id: 'components.header.sign-out',
        defaultMessage: 'Sign out',
    },
});
